import React from "react";
import { Typography, Button } from "antd";
import { Views } from "react-big-calendar";
import moment from "moment";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const { Title } = Typography;

const CalenderTimePicker = (props) => {
  const { calenderView, currentDate, onNextDate, onPreviousDate } = props;
  let date =
    calenderView === Views.DAY
      ? moment(currentDate).format("LL")
      : calenderView === Views.WEEK
      ? `${moment(currentDate).startOf("week").format("LL")} - ${moment(
          currentDate
        )
          .endOf("week")
          .format("LL")}`
      : moment(currentDate).format("MMMM YYYY");
  date =
    calenderView === Views.DAY
      ? `${date} (${moment(currentDate).format("dddd")})`
      : date;
  const disabledNext =
    calenderView === Views.WEEK &&
    !moment(moment(currentDate).add(1, "week")).isSame(
      moment(currentDate),
      "month"
    );

  const disabledPrevious =
    calenderView === Views.WEEK &&
    !moment(moment(currentDate).subtract(1, "week")).isSame(
      moment(currentDate),
      "month"
    );

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
        width: "100%",
      }}
    >
      <Button
        type="text"
        shape="circle"
        icon={<RightOutlined />}
        onClick={onPreviousDate}
        disabled={disabledPrevious}
      />
      <Title level={4} style={{ margin: "0px", lineHeight: 1.5 }}>
        {date}
      </Title>
      <Button
        type="text"
        shape="circle"
        icon={<LeftOutlined />}
        onClick={onNextDate}
        disabled={disabledNext}
      />
    </div>
  );
};

export default CalenderTimePicker;
